var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.styleType===null||_vm.styleType==='origin'||this.styleType==='0'?'my_outbox':`my_outbox_${_vm.styleType}`},[_c('div',{ref:"box",staticClass:"my-inbox"},_vm._l((_vm.attention),function(ele,index){return _c('div',{key:index,staticClass:"my-list"},[_vm._v(_vm._s(ele['title']))])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }